import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

function AskToDownloadPDFDialog(props) {
  const title = props.title;
  const description = props.description;
  const open = props.open;
  const handleCloseWithConfirm = props.handleCloseWithConfirm;
  const handleCancel = props.handleCancel && props.handleCancel;
  const primaryButtonIcon = props.primaryButtonIcon && props.primaryButtonIcon;
  const secondaryButtonIcon = props.secondaryButtonIcon && props.secondaryButtonIcon;
  const mainIconAsImage = props.mainIconAsImage && props.mainIconAsImage;

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "500px",
          borderRadius: "12px",
          padding: "36px",
          paddingTop: "0px",
        },
      }}
      open={open}
      aria-labelledby="task-saved-dialog-title"
    >
      <DialogTitle></DialogTitle>
      <DialogContent className="text-center">
        <div className="flex justify-center">
          <img src={mainIconAsImage} />
        </div>
        <div className="text-[24px] leading-[2rem] font-bold text-gray-900 mb-[0.25rem] mt-[1.5rem]">{title}</div>
        <p className="text-[16px] leading-[1.5rem] tracking-[0.15px] text-[#49454F]">{description}</p>
      </DialogContent>
      <DialogActions className="flex flex-col gap-y-[0.5rem]">
        <button
          onClick={() => {
            handleCloseWithConfirm();
          }}
          className="teepee-button flex items-center gap-2 hover:bg-black w-full sm:w-[100%] justify-center"
        >
          <span className="flex items-center justify-center gap-2">
            {primaryButtonIcon && primaryButtonIcon}
            Download PDF
          </span>
        </button>

        <button onClick={() => handleCancel()} className="teepee-back-button !ml-0 hover:bg-black hover:text-white w-[full] sm:w-[100%]">
          <span className="flex items-center justify-center gap-2">
            {secondaryButtonIcon && secondaryButtonIcon}
            Cancel
          </span>
        </button>
      </DialogActions>
    </Dialog>
  );
}
export default AskToDownloadPDFDialog;
